<div class="page">
    <div class="page-header">
        <div class="header-left">
            <mat-icon class="back-icon" routerLink="/onsaleperiod">arrow_back</mat-icon>
            <h3>{{ 'onSale.add.title' | translate }}</h3>
        </div>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'onSale.add.basicData' | translate }}</h4>
        <form novalidate [formGroup]="saleForm!">
            <div class="form-row">
                <label for="onSaleName">{{ 'onSale.add.name' | translate }} <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="onSaleName" id="onSaleName" type="text" required [(ngModel)]="onSaleName" />
                </div>
            </div>
            <div class="form-row">
                <label for="onSaleStartDate">{{ 'onSale.add.startDate' | translate }} <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="onSaleStartDate" id="onSaleStartDate" type="date" required />
                </div>
            </div>
            <div class="form-row">
                <label for="onSaleEndDate">{{ 'onSale.add.endDate' | translate }} <span class="required">*</span></label>
                <div class="form-input">
                    <input formControlName="onSaleEndDate" id="onSaleEndDate" type="date" required />
                </div>
            </div>
        </form>
    </div>

    <div class="form-card">
        <h4 class="section-title">{{ 'onSale.add.products' | translate }}</h4>
        <div class="drag-and-drop-container">
            <div class="search-main-container">
                <div class="search-bar">
                    <mat-icon fontIcon="search" />
                    <input placeholder="{{ 'onSale.add.searchPlaceholder' | translate }}" type="search" [(ngModel)]="searchText" />
                </div>
                <div class="category-info">
                    <span>{{ onSaleName || ('onSale.add.newSale' | translate) }} — {{ 'onSale.add.elementCount' | translate }}: {{ productsToSale.length }}</span>
                </div>
            </div>
            <div class="drag-and-drop">
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'onSale.add.availableProducts' | translate }}</h5>
                    <div class="products-list">
                        @for (product of products | filter: searchText; track product) {
                            <div class="product-item">
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--add" (click)="addSaleProduct(product)">add_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
                <div class="products-panel">
                    <h5 class="panel-title">{{ 'onSale.add.saleProducts' | translate }}</h5>
                    <div class="products-list">
                        @for (product of productsToSale; track product) {
                            <div class="product-item">
                                <span>{{ product.author + ': ' + product.title }}</span>
                                <mat-icon class="action-icon action-icon--remove" (click)="deleteFromSale(product)">remove_circle_outline</mat-icon>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="submit-row">
            <button type="button" class="btn btn-submit" [disabled]="!onSaleName" (click)="addOnSalePeriod()">
                {{ 'onSale.add.submitButton' | translate }}
            </button>
        </div>
    </div>
</div>
